import enrollmentFileProcessing from 'Enrollment/ducks/enrollmentFileProcessing';
import enrollmentFileProcessingReject from 'Enrollment/ducks/enrollmentFileProcessingReject';
import enrollTrackUser from 'Enrollment/ducks/enrollTrackUser';
import unprocessedEnrollmentFiles from 'Enrollment/ducks/enrollmentFilesNotProcessed';
import employerEnrollment from 'Enrollment/ducks/employerEnrollment';
import genelcoBatchFileManagementState from 'Enrollment/ducks/genelcoBatchFileManagement';

export default {
  employerEnrollment,
  enrollmentFileProcessing,
  enrollmentFileProcessingReject,
  enrollTrackUser,
  unprocessedEnrollmentFiles,
  genelcoBatchFileManagementState
};
